<script>
export default {
  inject: ['$axios'],
  props: {
    appVersionNumber: String,
    appUpdatingStatus: Boolean,
    appUpdatedStatus: Boolean,
  },
  data() {
    return {
      updateText: '',
      updateTextSpinner: '',
      checkingUpdates: true,
      needToDownloadLatest: false,
      latestVersionNumber: '',
      appUpdating: false,
      appUpdated: false,
      showRefreshButton: false,
      serverVersionMismatch: false
    };
  },
  methods: {
    reloadApp() {
      location.reload();
    },
    appUpdateEvent(e) {
      console.log(e.detail);
      let vm = this;
      switch (e.detail) {
        case 'update downloading':
          vm.appUpdating = true;
          vm.appUpdated = false;
          break;
        case 'updated':
          vm.appUpdating = false;
          vm.appUpdated = true;
          vm.showRefreshButton = true;
          break;
      }
    },
  },
  mounted() {
    let vm = this;

    // console.log('appVersionNumber', vm.appVersionNumber);
    // console.log('appUpdatingStatus', vm.appUpdatingStatus);
    // console.log('appUpdatedStatus', vm.appUpdatedStatus);

    document.addEventListener('updateEvent', this.appUpdateEvent);


    vm.$axios
        .post(`/auth/app/${vm.appVersionNumber}`, {}, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          switch (response.data.success) {
            case 'true':
              vm.checkingUpdates = false;
              vm.needToDownloadLatest = response.data.latestVersion !== 'true';
              if (vm.needToDownloadLatest) {
                vm.latestVersionNumber = response.data.latestVersion;
              } else {
                vm.latestVersionNumber = '';
                vm.$emit('versionIsUpToDate', {});
              }
              break;
            case 'false':
              vm.serverVersionMismatch = true;
              break;
          }
        })


  },
  computed: {
    appIsRegistered() {
      let vm = this;
      if (vm.registryStatus) {
        return 'App Registered';
      } else {
        return 'App Not Registered';
      }
    },
    appIsOnline() {
      let vm = this;
      if (vm.onlineStatus) {
        return 'Online';
      } else {
        return 'Offline';
      }
    },
    // appIsUpToDate() {
    //   let vm = this;
    //   if (vm.appUpdatingStatus) {
    //     vm.updateText = 'Downloading Update';
    //     return vm.updateText;
    //   } else {
    //     if (vm.updateText === 'Downloading Update') {
    //       vm.updateText = 'Update Downloaded';
    //     } else {
    //       vm.updateText = 'Latest App Running';
    //     }
    //     return vm.updateText;
    //   }
    // },
    appVersionChecking() {
      let vm = this;
      if (vm.appUpdatingStatus) {
        vm.updateTextSpinner = 'Downloading Update';
        return vm.updateTextSpinner;
      } else {
        if (vm.updateTextSpinner === 'Downloading Update') {
          vm.updateTextSpinner = 'Update Downloaded';
        } else {
          if (vm.serverVersionMismatch) {
            vm.updateTextSpinner = 'Update found';
            vm.showRefreshButton = true;
          } else {
            vm.updateTextSpinner = 'Checking for updates';
          }

        }
        return vm.updateTextSpinner;
      }
    },
    refreshAppNow() {
      let vm = this;
      return !!vm.appUpdatedStatus;
    },
  },
  watch: {
    appUpdatingStatus: {
      async handler(newValue) {
        // let vm = this;
        console.log('new appUpdatingStatus', newValue);
      },
      deep: true
    },
    appUpdatedStatus: {
      async handler(newValue) {
        // let vm = this;
        console.log('new appUpdatedStatus', newValue);
      },
      deep: true
    }
  }
};

</script>

<template>
  <div id="page-style">
    <div class="app-version top-version-text">{{ appIsRegistered }} <span class="pipe-divider">|</span> {{
        appIsOnline
      }}
    </div>
    <div class="loginBox">
      <div class="inner">

        <div class="top">
          <div class="title">
            <span class="AMH-darkGray-text">S</span>
            <span class="AMH-darkGray-text">.</span>
            <span class="AMH-darkGray-text">A</span>
            <span class="AMH-darkGray-text">.</span>
            <span class="AMH-darkGray-text">F</span>
            <span class="AMH-darkGray-text">.</span>
            <span class="AMH-darkGray-text">E</span>
            <span class="AMH-darkGray-text">.</span>
          </div>
          <img alt="AMH logo" src="../assets/icon.png" class="logo">
        </div>

        <div v-if="checkingUpdates || needToDownloadLatest" class="check-version-container">
          <div class="check-version"></div>
          {{ appVersionChecking }}

          <div v-if="needToDownloadLatest">Latest Version: {{ latestVersionNumber }}</div>
          <div v-if="appUpdating">Update Downloading</div>
          <div v-if="appUpdated">App updated</div>

          <a v-if="refreshAppNow || showRefreshButton" class="button is-rounded is-small refresh-btn"
             v-on:click="reloadApp">Reload</a>
        </div>
      </div>
    </div>
    <div class="app-version bottom-version-text">Surgical Access For Everyone <span class="pipe-divider">|</span>
      {{ appVersionNumber }}
    </div>
  </div>
</template>

<style lang="scss">

.AMH-transitionGray-text {
  color: #767576 !important;
}

.AMH-darkGray-text {
  color: #221f20 !important;
}

.AMH-blue-text {
  color: #276eb6 !important;
}

.AMH-red-text {
  color: #ce3727 !important;
}

.AMH-yellow-text {
  color: #f8d246 !important;
}

.AMH-green-text {
  color: #4d9041 !important;
}

.top-version-text, .bottom-version-text {
  background-color: white;
}

.top-version-text {
  border-radius: 15px 15px 0 0;
}

.bottom-version-text {
  border-radius: 0 0 15px 15px;
}

.forgot-pass-link {
  margin-top: 10px;
  color: green;
  font-weight: bold;
  cursor: pointer;
}

.refresh-btn {
  margin-left: 10px;
}

.login-error, .register-error {
  height: 40px;
  padding: 10px;
  margin-top: 20px;
}

.success-reg-link {
  margin-top: 20px;
}

@mixin box {
  box-shadow: 1px 1px 2px 1px #ccc;
}

@mixin field {
  border: 1px solid #aaa;
  height: 40px;
  padding: 10px;
  margin-top: 20px;
  border-radius: 5px;
  box-sizing: border-box;
}

input[type="text"] {
  @include field;
}

input[type="email"] {
  @include field;
}

input[type="password"] {
  @include field;
}

.invalid {
  border: 2px solid red !important;

  &::placeholder {
    color: red;
  }
}

.errorMessage {
  color: red;
  margin: 10px;
  top: 5px;
}

.w100 {
  width: 100%;
}

#app {
}

.logo {
  width: 300px;
  margin-bottom: 10px;
}

.action {
  height: 40px;
  text-transform: uppercase;
  border-radius: 25px;
  width: 100%;
  border: none;
  cursor: pointer;
  background: green;
  margin-top: 20px;
  color: #fff;
  font-size: 1.2rem;
  @include box;
}

.action-disabled {
  color: #eee;
  background: #aaa;
  cursor: auto;
}

.top {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 10px;
}

.title {
  width: 100%;
  font-size: 1.8rem;
  margin-bottom: 10px;
  text-align: center;
}

.subtitle {
  .subtitle-action {
    color: green;
    font-weight: bold;
    cursor: pointer;
  }
}

.form-subtitle {
  margin-bottom: 0 !important;
}

.page-style {
  background: linear-gradient(
          to bottom,
          rgba(96, 108, 136, 1) 0%,
          rgba(63, 76, 107, 1) 100%
  ) no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-family: sans-serif;
}

.loginBox {
  background: rgba(244, 244, 244, 0.9);
  max-width: 500px;
  padding: 25px 55px;
  animation: slideInTop 1s;
}

@keyframes slideInTop {
  from {
    opacity: 0;
    transform: translateY(-30%);
  }

  to {
    opacity: 100;
    transform: translateY(0%);
  }
}

@media screen and (min-width: 440px) {
  .loginBox {
    @include box;
  }
}

@media screen and (max-width: 440px) {
  html {
    background: #fff;
    align-items: start;
    justify-content: start;
  }

  .loginBox {
    padding: 25px 25px;
    max-width: 100vw;
  }
}

.pass-view-btn {
  margin-top: 20px;
  border: 1px solid #aaa !important;
  height: 40px !important;
  border-radius: 0 5px 5px 0 !important;
  box-sizing: border-box;
}


.check-version {
  background-image: url("../assets/img/colorful-spinner.png");
  background-size: cover;
  animation: animName 2s linear infinite;
  width: 50px;
  height: 50px;
  margin: 20px;
}

@keyframes animName {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.check-version-container {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.pipe-divider {
  font-weight: bolder;
}

</style>
